import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    overlay: {
        width: '100vw',
        minHeight: '100vh',
        backgroundColor: '#60B3FD',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    loginForm: {
        width: '330px',
        minHeight: '364px',
        height: 'auto',
        position: 'absolute',
        borderRadius: '5px',
        marginBottom: 'auto',
        backgroundColor: '#fff',
        boxShadow: '0px 8px 18px #0000001f'
    },
    suImage: {
        paddingTop: '32px',
        textAlign: 'center'
    },
    input: {
        padding: '0px'
    },
    loginButton: {
        backgroundColor: '#5EB6FD !important',
        fontSize: '12px !important',
        width: '86%'
    },
    lengthInput: {
        width: '278px',
        fontSize: '12px'
    },
    customTextField: {
        width: '100%',
        '& input::placeholder': {
            fontSize: '13px'
        }
    },
    inputSize: {
        fontSize: `${theme.palette.textSizeLarge}!important`
    },
    formInputs: {
        padding: '0 25px'
    },
    formInput_1: {
        paddingTop: '18px'
    },
    loginButtonDiv: {
        textAlign: 'center',
        paddingTop: '39px'
    },
    formLabel: {
        fontSize: theme.palette.textSizeLarge,
        color: '#21262B',
        padding: '6px 0'
    },
    iconInput: {
        color: '#BBBBBB',
        transform: 'scale(0.8)'
    },
    ErrorMessage: {
        paddingTop: '10px',
        color: '#f48c2b',
        fontWeight: 500
    },
    customFormInput: {
        width: '100%'
    }
}));
